export function ChartFactory() {var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  switch (type.toLowerCase()) {
    case 'line':return createLineChart;
    case 'pie':return createPieChart;
    default:return createLineChart;}

}

var possibleChartistEvents = [
'created',
'draw',
'data',
'optionsChanged',
'animationBegin',
'animationEnd'];


function createLineChart(Chartist, container, data) {
  var chart = new Chartist.Line(container, null, {
    fullWidth: true,
    height: "300px",
    showArea: true,
    lineSmooth: Chartist.Interpolation.simple({
      divisor: 2 }),

    axisX: {
      type: Chartist.FixedScaleAxis,
      divisor: 7,
      showGrid: true,
      labelInterpolationFnc: function labelInterpolationFnc(value, index) {
        return data.labels[index];
      } } });



  if (data.series[1]) {
    chart.update({
      series: [{
        name: data.series[0].name,
        className: data.series[0].className,
        data: data.series[0].data.map(function (h, i) {
          return {
            x: new Date(h.x),
            y: h.y };

        }) },

      {
        name: data.series[1].name,
        className: data.series[1].className,
        data: data.series[1].data.map(function (h, i) {
          return {
            x: new Date(h.x),
            y: h.y };

        }) }] });



  } else {
    chart.update({
      series: [{
        name: data.series[0].name,
        className: data.series[0].className,
        data: data.series[0].data.map(function (h, i) {
          return {
            x: new Date(h.x),
            y: h.y };

        }) }] });



  }


  chart.on('draw', function (data) {
    if (data.type === 'line' || data.type === 'area') {
      data.element.animate({
        d: {
          begin: 400 * data.index,
          dur: 800,
          from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
          to: data.path.clone().stringify(),
          easing: 'easeOutQuart' } });


    } else if (data.type === 'point') {
      var circle = new Chartist.Svg('circle', {
        cx: data.x,
        cy: data.y,
        r: 6,
        style: '' },
      'ct-point');

      data.element.replace(circle).animate({
        opacity: {
          begin: 200 * data.index,
          dur: 800,
          from: 0,
          to: 1 } });


    } else if (data.type === 'grid') {
      var animations = {};
      var pos1Animation = {
        begin: 50 * data.index,
        dur: 100,
        from: data[data.axis.units.pos + '1'] - 30,
        to: data[data.axis.units.pos + '1'] };

      animations[data.axis.units.pos + '1'] = pos1Animation;

      animations['opacity'] = {
        begin: 100 * data.index,
        dur: 100,
        from: 0,
        to: 1 };


      data.element.animate(animations);
    }
  });

  return chart;
}

function createPieChart(Chartist, container, data) {
  var chart = new Chartist.Pie(container, data, {
    labelInterpolationFnc: function labelInterpolationFnc(value) {
      return Math.round(value / data.series.reduce(function (a, b) {return a + b;}) * 100) + '%';
    } });


  return chart;
}